import BloqueioItem from "@/Models/Pessoa/Bloqueio/BloqueioItem";
import { EnumBloqueioTipo } from "@/Models/Pessoa/Bloqueio/BloqueioTipo";
import { Axios } from "@/Services/Axios";
import { QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export function useBloqueioItemListarPorBloqueio({
    codBloqueio,
    codBloqueioTipo,
    onFinish,
    ...rest
}:QueryBasicaParam<AxiosResponse<BloqueioItem[]>, BloqueioItem[], {
    codBloqueio:number,
    codBloqueioTipo:keyof typeof EnumBloqueioTipo,
    onFinish?:() => void
}>) {
    return useQuery({
        ...rest,
        queryKey : [ "Pessoa.Bloqueio.BloqueioItem", `Pessoa.Bloqueio.${codBloqueio}.BloqueioItem.${codBloqueioTipo}` ],
        queryFn : () => Axios.get<BloqueioItem[]>(`pessoa/bloqueio/${codBloqueio}/item/${codBloqueioTipo}`).finally(onFinish),
        select(data) {
            return (data.data ?? []).map(m => {
                m.dataResolucao = !!m.dataResolucao ? new Date(m.dataResolucao as any) : undefined;
                m.dataCriacao = new Date(m.dataCriacao as any);
                return m;
            });
        },
        staleTime : 1000 * 60 * 0
    });
}